import {
  GetSupplierHearingList
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

/**
 * GET /api/supplier/hearing/status/listのゲートウェイクラス
 */
export class StatusCheckGateway {
  /** 業者ヒアリング状況確認-明細部取得 */
  static getStatusCheckResultList = async (params: {
    simulationY: string
    simulationM: string
    branchCdList?: string[]
    expenseCd?: string
    supplierNm?: string
    replyStsCdList?: string[]
    sortOrder: string
  }) => {
    return await yamadumiApi.get<GetSupplierHearingList>(
      '/api/supplier/hearing/status/list',
      params
    )
  }
}
